<app-area-search-selector-result icon='my-location' [display]='NAME' [name]='NAME' [wait]='true' [state]='state'
    (selected)='select()'
></app-area-search-selector-result>